module.exports = __webpack_public_path__ + "static/media/nighttime.fb25d8d8.svg";